<!-- ================优质资源-课件详情====================-->
<template>
    <div class="premium-courseware-info-page">
        <home-head />
        <div class="premium-courseware-info-body">
            <div class="premium-courseware-info-inner" v-loading="loading">
                <!-- 标题区 -->
                <div class="courseware-info-header">
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                    <div class="courseware-info-title" :title="coursewareInfo.name">{{ coursewareInfo.name || '课件详情' }}</div>
                    <div class="header-placeholder"></div>
                </div>

                <!-- 主体内容 -->
                <div class="courseware-info-main" v-if="coursewareInfo.coursewareId">
                    <!-- 左侧工具栏 -->
                    <div class="courseware-info-toolbar">
                        <div class="toolbar-item" :class="{ active: isCollect }" @click="handleCollect">
                            <el-icon class="toolbar-icon"><Star /></el-icon>
                            <span class="toolbar-text">收藏</span>
                        </div>
                        <div class="toolbar-item" :class="{ active: isLike }" @click="handleLike">
                            <el-icon class="toolbar-icon"><Pointer /></el-icon>
                            <span class="toolbar-text">点赞</span>
                        </div>
                    </div>

                    <!-- 左侧章节树（直接展示） -->
                    <div class="courseware-chapter-panel">
                        <div class="chapter-panel-header">
                            <span>课件章节</span>
                        </div>
                        <div class="chapter-tree-wrapper">
                            <el-tree
                                v-if="dataSource.length > 0"
                                :data="dataSource"
                                highlight-current
                                ref="chapterTree"
                                node-key="coursewareId"
                                default-expand-all
                                :expand-on-click-node="false"
                                :props="{ label: 'name', id: 'coursewareId', children: 'childrenList' }"
                                @node-click="handleChapterClick">
                                <template #default="{ node, data }">
                                    <div class="custom-tree-node" :title="node.label">
                                        <el-icon :size="15" v-if="hasSwf(data)">
                                            <VideoPlay />
                                        </el-icon>
                                        <span class="tree-node-label">{{ node.label }}</span>
                                    </div>
                                </template>
                            </el-tree>
                            <div class="chapter-empty" v-else>暂无章节</div>
                        </div>
                    </div>

                    <!-- 中间内容区 -->
                    <div class="courseware-info-content">
                        <!-- 课件推荐说明 -->
                        <div class="courseware-recommend" v-if="coursewareInfo.recommend">
                            {{ coursewareInfo.recommend }}
                        </div>

                        <!-- 课件列表 -->
                        <div class="courseware-section" v-if="activeObj.swfList && activeObj.swfList.length > 0">
                            <div class="section-title">课件内容</div>
                            <div class="swf-list">
                                <div class="swf-card cursor" v-for="(item, index) in activeObj.swfList" :key="index" @click="playSwf(item)">
                                    <div class="swf-cover">
                                        <div class="swf-name" :title="item.swfName">{{ item.swfName }}</div>
                                        <img class="play-icon" src="@/assets/image/played.png" alt="播放" />
                                    </div>
                                    <div class="swf-title" :class="{ active: activeSwf.swfId == item.swfId }" :title="item.swfName">
                                        {{ item.swfName }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 附件列表 -->
                        <div class="courseware-section">
                            <div class="section-title">课件附件</div>
                            <div class="attachment-list" v-if="showFileList.length > 0">
                                <div class="attachment-item" v-for="(item, index) in showFileList" :key="index">
                                    <div class="attachment-name" @click="downloadFile(item)" :title="item.fileName">{{ item.fileName }}</div>
                                    <div class="attachment-actions">
                                        <el-image v-if="item.imgUrl && item.pages" class="attachment-action-icon"
                                                  :src="require('@/assets/file/file_view_b22222.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl, item.pages)"
                                                  @click="handleFileStatus(item.status)">
                                        </el-image>
                                        <div class="attachment-action-icon download" @click="downloadFile(item)">
                                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="22" height="20"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#b22222"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#b22222"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="file-empty" v-else>
                                <div class="empty-icon">
                                    <img src="@/assets/image/data_empty.png" alt="暂无附件" />
                                </div>
                                <div class="empty-text">暂无附件</div>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧信息栏 -->
                    <div class="courseware-info-sidebar">
                        <div class="sidebar-section">
                            <div class="info-title">课件信息</div>
                            <div class="courseware-meta">
                                <div class="meta-item" v-if="coursewareInfo.periodName || coursewareInfo.gradeName || coursewareInfo.subjectName">
                                    <span class="meta-label">学段/年级/学科</span>
                                    <span class="meta-value">{{ formatCourseRange }}</span>
                                </div>
                                <div class="meta-item" v-if="coursewareInfo.coursewareTypeName">
                                    <span class="meta-label">课件类型</span>
                                    <span class="meta-value">{{ coursewareInfo.coursewareTypeName }}</span>
                                </div>
                                <div class="meta-item" v-if="coursewareInfo.viewCount !== undefined">
                                    <span class="meta-label">浏览量</span>
                                    <span class="meta-value">{{ coursewareInfo.viewCount || 0 }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="courseware-info-empty" v-else-if="!loading">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无课件信息</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { infoCourseware } from "@/api/admin/courseware";
import { addOrCancelCollect, judgeIsCollect } from "@/api/admin/collect";
import { addOrCancelLike, judgeIsLike } from "@/api/admin/likes";
import { downloadFile } from "@/utils/download";
import homeHead from "@/components/common/homeHead.vue";

export default {
    name: "premiumCoursewareInfo",
    components: { homeHead },
    data() {
        return {
            loading: false,
            coursewareId: "",
            coursewareInfo: {},
            isCollect: false,
            isLike: false,
            dataSource: [],
            activeObj: {},
            activeSwf: {},
            showFileList: []
        };
    },
    computed: {
        formatCourseRange() {
            const parts = [];
            if (this.coursewareInfo.periodName) parts.push(this.coursewareInfo.periodName);
            if (this.coursewareInfo.gradeName) parts.push(this.coursewareInfo.gradeName);
            if (this.coursewareInfo.subjectName) parts.push(this.coursewareInfo.subjectName);
            return parts.join("-") || "--";
        }
    },
    watch: {
        "$route.query.coursewareId": {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.coursewareId = newVal;
                    this.resetData();
                    this.queryCoursewareInfo();
                    this.judgeCollectAndLike();
                }
            }
        }
    },
    created() {},
    mounted() {},
    methods: {
        /* ===============重置数据===================== */
        resetData() {
            this.coursewareInfo = {};
            this.dataSource = [];
            this.activeObj = {};
            this.activeSwf = {};
            this.showFileList = [];
            this.isCollect = false;
            this.isLike = false;
        },

        /* ===============查询课件详情===================== */
        queryCoursewareInfo() {
            this.loading = true;
            infoCourseware({ coursewareId: this.coursewareId }).then(res => {
                if (res.data.code === 1) {
                    this.coursewareInfo = res.data.data || {};
                    this.dataSource = [this.coursewareInfo];
                    this.initDefaultChapter();
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============初始化默认章节===================== */
        initDefaultChapter() {
            const info = this.coursewareInfo;
            let targetObj = null;
            const findFirstLeafWithSwf = (data) => {
                if (!data) return;
                if (data.swfList && data.swfList.length > 0) {
                    targetObj = data;
                    return true;
                }
                if (data.childrenList && data.childrenList.length > 0) {
                    for (let child of data.childrenList) {
                        if (findFirstLeafWithSwf(child)) return true;
                    }
                }
                return false;
            };
            if (info.swfList && info.swfList.length > 0) {
                targetObj = info;
            } else {
                findFirstLeafWithSwf(info);
            }
            this.activeObj = targetObj || info;
            this.setActiveSwfAndFiles();
            this.$nextTick(() => {
                if (this.$refs.chapterTree && targetObj) {
                    this.$refs.chapterTree.setCurrentKey(targetObj.coursewareId);
                }
            });
        },

        /* ===============章节点击===================== */
        handleChapterClick(data) {
            this.activeObj = data;
            this.setActiveSwfAndFiles();
        },

        /* ===============判断是否有课件===================== */
        hasSwf(data) {
            return data.swfList && data.swfList.length > 0;
        },

        /* ===============设置当前课件及附件===================== */
        setActiveSwfAndFiles() {
            if (this.activeObj.swfList && this.activeObj.swfList.length > 0) {
                this.activeSwf = this.activeObj.swfList[0];
                this.showFileList = this.activeSwf.fileList || [];
            } else {
                this.activeSwf = {};
                this.showFileList = [];
            }
        },

        /* ===============播放课件===================== */
        playSwf(item) {
            this.activeSwf = item;
            this.showFileList = item.fileList || [];
            const url = item.swfUrl;
            if (!url) {
                this.$message.info("该课件暂无可播放地址");
                return;
            }
            const routeUrl = this.$router.resolve({
                path: "/premium/coursewarePlayer",
                query: { page: window.btoa(window.encodeURIComponent(url)) }
            });
            window.open(routeUrl.href, "_blank");
        },

        /* ===============下载附件===================== */
        downloadFile(item) {
            const url = item.fileUrl || item.url || "";
            const name = item.fileName || "未命名文件";
            if (!url) {
                this.$message.info("该附件暂无可下载地址");
                return;
            }
            downloadFile(url, name);
        },

        /* ===============处理文件预览状态===================== */
        handleFileStatus(status) {
            if (status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览");
            }
        },

        /* ===============生成文件预览图列表===================== */
        gainFileImgList(baseUrl, pages) {
            const list = [];
            const total = pages || 1;
            for (let i = 1; i <= total; i++) {
                list.push(baseUrl + "/" + i + ".png");
            }
            return list;
        },

        /* ===============判断收藏/点赞状态===================== */
        judgeCollectAndLike() {
            judgeIsCollect({
                relationId: this.coursewareId,
                collectType: 2,
                businessType: 6
            }).then(res => {
                if (res.data.code === 1) {
                    this.isCollect = !!res.data.data;
                }
            });
            judgeIsLike({ relationId: this.coursewareId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !!res.data.data;
                }
            });
        },

        /* ===============收藏===================== */
        handleCollect() {
            addOrCancelCollect({
                relationId: this.coursewareId,
                collectType: 2,
                businessType: 6
            }).then(res => {
                if (res.data.code === 1) {
                    this.isCollect = !this.isCollect;
                    this.$message.success(this.isCollect ? "收藏成功" : "已取消收藏");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },

        /* ===============点赞===================== */
        handleLike() {
            addOrCancelLike({ relationId: this.coursewareId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !this.isLike;
                    this.$message.success(this.isLike ? "点赞成功" : "已取消点赞");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },

        /* ===============返回===================== */
        goBack() {
            this.$router.back();
        }
    }
};
</script>

<style scoped>
.premium-courseware-info-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.premium-courseware-info-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.premium-courseware-info-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.courseware-info-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.courseware-info-title {
    flex: 1;
    text-align: center;
    font-size: 22px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 1px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 28px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 8px;
    font-size: 16px;
}

.header-placeholder {
    width: 108px;
    flex-shrink: 0;
}

/* 主体内容 */
.courseware-info-main {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    padding: 16px;
    position: relative;
}

/* 左侧工具栏 */
.courseware-info-toolbar {
    width: 70px;
    flex-shrink: 0;
    border-right: 1px solid #e5e7eb;
    margin-right: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 0;
    box-sizing: border-box;
    background-color: #ffffff;
}

.toolbar-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 14px 0;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #4b5563;
}

.toolbar-item:hover {
    color: #b22222;
    background-color: #fef2f2;
}

.toolbar-item.active {
    color: #b22222;
}

.toolbar-icon {
    font-size: 22px;
    margin-bottom: 6px;
}

.toolbar-text {
    font-size: 12px;
    font-family: sans-serif;
    text-align: center;
    line-height: 1.4;
}

/* 左侧章节树 */
.courseware-chapter-panel {
    width: 280px;
    flex-shrink: 0;
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-right: 16px;
}

.chapter-panel-header {
    height: 42px;
    line-height: 42px;
    padding: 0 14px;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
    flex-shrink: 0;
}

.chapter-tree-wrapper {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 10px;
}

.chapter-empty {
    padding: 40px 0;
    text-align: center;
    color: #9ca3af;
    font-size: 14px;
}

.custom-tree-node {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.tree-node-label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 中间内容区 */
.courseware-info-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
}

.courseware-recommend {
    font-size: 14px;
    color: #4b5563;
    line-height: 1.7;
    margin-bottom: 16px;
    word-break: break-all;
    flex-shrink: 0;
}

.courseware-section {
    margin-bottom: 20px;
    flex-shrink: 0;
}

.section-title {
    font-size: 15px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #b22222;
}

/* 课件列表 */
.swf-list {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
}

.swf-card {
    width: 100%;
}

.swf-cover {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: linear-gradient(135deg, #034306 0%, #0a5c0e 100%);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    margin-bottom: 8px;
}

.swf-name {
    width: 80%;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.play-icon {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.9;
    transition: all 0.2s ease;
}

.swf-card:hover .play-icon {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
}

.swf-title {
    font-size: 13px;
    color: #4b5563;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
}

.swf-title.active {
    color: #b22222;
    font-weight: bold;
}

/* 附件列表 */
.attachment-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.attachment-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background-color: #ffffff;
    transition: background-color 0.2s ease;
}

.attachment-item:hover {
    background-color: #f9fafb;
}

.attachment-name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #1f2937;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 12px;
}

.attachment-name:hover {
    color: #b22222;
}

.attachment-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.attachment-action-icon {
    width: 22px;
    height: 22px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.attachment-action-icon ::v-deep img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.attachment-action-icon.download svg {
    width: 22px;
    height: 22px;
}

.file-empty {
    min-height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.file-empty .empty-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
}

.file-empty .empty-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* 右侧信息栏 */
.courseware-info-sidebar {
    width: 280px;
    flex-shrink: 0;
    border-left: 1px solid #e5e7eb;
    margin-left: 16px;
    padding-left: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
}

.sidebar-section {
    margin-bottom: 20px;
}

.info-title {
    font-size: 15px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #b22222;
}

.courseware-meta {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.meta-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.meta-label {
    font-size: 12px;
    color: #9ca3af;
}

.meta-value {
    font-size: 14px;
    color: #1f2937;
}

/* 暂无数据 */
.courseware-info-empty {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.courseware-info-empty .empty-icon {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
}

.courseware-info-empty .empty-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
}

/* 滚动条统一 */
.courseware-info-content::-webkit-scrollbar,
.courseware-info-sidebar::-webkit-scrollbar,
.chapter-tree-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px; 
}

.courseware-info-content::-webkit-scrollbar-track,
.courseware-info-sidebar::-webkit-scrollbar-track,
.chapter-tree-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.courseware-info-content::-webkit-scrollbar-thumb,
.courseware-info-sidebar::-webkit-scrollbar-thumb,
.chapter-tree-wrapper::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.cursor {
    cursor: pointer;
}

@media (max-width: 1280px) {
    .premium-courseware-info-inner { padding: 0 16px; }
    .courseware-info-title { font-size: 20px; }
    .courseware-info-main { padding: 12px; }
    .courseware-info-sidebar { width: 220px; margin-left: 12px; padding-left: 12px; }
    .courseware-chapter-panel { width: 240px; margin-right: 12px; }
    .swf-list { grid-template-columns: repeat(3, minmax(0, 1fr)); }

}

@media (max-width: 1024px) {
    .courseware-info-main { flex-direction: column; overflow-y: auto; }
    .courseware-chapter-panel {
        width: 100%;
        height: 260px;
        margin-right: 0;
        margin-bottom: 12px;
    }
    .courseware-info-sidebar {
        width: 100%;
        border-left: none;
        margin-left: 0;
        padding-left: 0;
        border-top: 1px solid #e5e7eb;
        padding-top: 12px;
        margin-top: 12px;
    }
    .swf-list { grid-template-columns: repeat(3, minmax(0, 1fr)); }

}

@media (max-width: 768px) {
    .courseware-info-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .courseware-info-title { width: 100%; text-align: left; padding: 0; }
    .header-placeholder { display: none; }
    .swf-list { grid-template-columns: repeat(2, minmax(0, 1fr)); }

}
</style>
